// client/src/services/groupService.js
import api from '../api';

export async function fetchGroups(sellerId) {
  const res = await api.get(`/api/products/seller/${sellerId}/groups`);
  return res.data;
}

export async function createNewGroup(sellerId, name, subcategory) {
  const res = await api.post('/api/products/seller/groups', {
    seller_id: Number(sellerId),
    name,
    subcategory,
  });
  return res.data;
}

export async function updateGroupById(groupId, sellerId, data) {
  const res = await api.put(`/api/products/seller/groups/${groupId}`, {
    seller_id: Number(sellerId),
    ...data,
  });
  return res.data;
}

export async function removeGroup(groupId, sellerId) {
  const res = await api.delete(`/api/products/seller/groups/${groupId}`, {
    params: { seller_id: Number(sellerId) },
  });
  return res.data;
}

export async function fetchAvailableProducts(sellerId, subcategory) {
  const res = await api.get(`/api/products/seller/${sellerId}/available-for-group`, {
    params: { subcategory },
  });
  return res.data;
}

export async function assignProductToGroup(productId, sellerId, groupId, subcategory) {
  const res = await api.put(`/api/products/${productId}/meta`, {
    sellerId: Number(sellerId),   // camelCase
    groupId: groupId,
    subcategory,
  });
  return res.data;
}

export async function detachProductFromGroup(productId, sellerId) {
  const res = await api.put(`/api/products/${productId}/meta`, {
    sellerId: Number(sellerId),
    groupId: null,
  });
  return res.data;
}